/**
 * ログインフォーム（#login-form）のクライアント側バリデーション
 * 見学予約（visit-form-validation.js）と同様に login__fieldError / is-invalid で表示する
 */

import { isValidEmail } from './email-validation.js';

function trimValue(id) {
	const el = document.getElementById(id);
	return el ? el.value.trim() : '';
}

function clearErrorForControl(form, controlId) {
	form.querySelectorAll(`.login__fieldError[data-for="${controlId}"]`).forEach((n) => n.remove());
	const control = document.getElementById(controlId);
	if (!control) return;
	control.removeAttribute('aria-invalid');
	control.classList.remove('is-invalid');
}

export function clearLoginFormErrors(form) {
	form.querySelectorAll('.login__fieldError').forEach((n) => n.remove());
	form.querySelectorAll('.login__input.is-invalid').forEach((n) => n.classList.remove('is-invalid'));
	form.querySelectorAll('[aria-invalid="true"]').forEach((n) => n.removeAttribute('aria-invalid'));
}

function mountErrorParagraph(controlId, message) {
	const p = document.createElement('p');
	p.className = 'login__fieldError';
	p.setAttribute('data-for', controlId);
	p.setAttribute('role', 'alert');
	p.textContent = message;
	return p;
}

function showFieldError(form, controlId, message) {
	const control = document.getElementById(controlId);
	if (!control) return;

	clearErrorForControl(form, controlId);

	control.setAttribute('aria-invalid', 'true');
	control.classList.add('is-invalid');
	control.insertAdjacentElement('afterend', mountErrorParagraph(controlId, message));
}

function focusFirst(controlId) {
	const el = document.getElementById(controlId);
	el?.focus();
}

/**
 * @returns {boolean}
 */
export function validateLoginForm(form) {
	clearLoginFormErrors(form);

	const errors = [];

	const email = trimValue('login-email');
	if (!email) {
		errors.push(['login-email', 'メールアドレスを入力してください。']);
	} else if (!isValidEmail(email)) {
		errors.push(['login-email', 'メールアドレスの形式が正しくありません。']);
	}

	const password = trimValue('login-password');
	if (!password) {
		errors.push(['login-password', 'パスワードを入力してください。']);
	}

	if (errors.length === 0) {
		return true;
	}

	for (const [id, msg] of errors) {
		showFieldError(form, id, msg);
	}
	focusFirst(errors[0][0]);
	return false;
}

export function initLoginFormValidation(form) {
	if (!form || form.id !== 'login-form') return;

	const onEdit = (e) => {
		const t = e.target;
		if (!t || !t.id) return;
		if (form.contains(t)) {
			clearErrorForControl(form, t.id);
		}
	};

	form.addEventListener('input', onEdit);
	form.addEventListener('change', onEdit);
}
